<kendo-grid
  #kendogrid
  [data]="gridWrapper.gridData"
  [loading]="gridWrapper.loading"
  [height]="(bodyHeight$ | async) || 400"
  scrollable="virtual"
  rowHeight="54px"
  [skip]="gridWrapper.gridState.skip"
  [pageSize]="gridWrapper.gridState.take"
  kendoGridSelectBy="id"
  [sortable]="true"
  [groupable]="true"
  [reorderable]="true"
  [resizable]="true"
  [selectable]="false"
  filterable="menu"
  [group]="gridWrapper.gridState.group"
  [sort]="gridWrapper.gridState.sort"
  (groupChange)="gridWrapper.groupChanged($event)"
  (dataStateChange)="gridWrapper.onDataStateChange($event)"
  (add)="openEditDialog(undefined)"
  (remove)="delete($event)"
>
  <kendo-grid-messages
    [noRecords]="gridWrapper.loading ? '' : 'Aucun résultat'"
    filterClearButton="Effacer"
    filterFilterButton="Filtrer"
    groupPanelEmpty="Déplacer ici l'entête d'une colonne pour grouper..."
  >
  </kendo-grid-messages>

  <ng-template kendoGridToolbarTemplate>
    <input #mainFilter placeholder="Rechercher..." kendoTextBox (input)="gridWrapper.onFilter($event.target)" />
    <button
      mat-icon-button
      color="primary"
      [style.visibility]="mainFilter.value.length > 0 ? 'visible' : 'hidden'"
      (click)="mainFilter.value = ''; gridWrapper.clearFilter()"
    >
      <mat-icon>clear</mat-icon>
    </button>

    <div class="upload-container">
      <button
        *ngIf="existsSessionForCurrentUser$ | async"
        type="button"
        mat-raised-button
        (click)="fileInput.click()"
        [disabled]="uploading"
      >
        Choisir un PGM à ajouter ou modifier
      </button>
      <input hidden (change)="onFileSelected()" #fileInput id="fileInput" type="file" accept=".zip" />
      <mat-spinner style="margin-left: 10px" color="primary" [diameter]="20" *ngIf="uploading"></mat-spinner>
    </div>
  </ng-template>

  <kendo-grid-column field="description" title="Description" [groupable]="false" filterable="false"> </kendo-grid-column>
  <kendo-grid-column field="commentaire" title="Localisation" [groupable]="false" filterable="false"> </kendo-grid-column>
  <kendo-grid-column field="descriptionEtatDetaille" title="Etat détaillé">
    <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter" let-filterService="filterService">
      <app-multicheck-filter
        [isPrimitive]="true"
        [field]="column.field"
        [filterService]="filterService"
        [currentFilter]="filter"
        [data]="distinctPrimitive(column.field)"
      ></app-multicheck-filter>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-command-column title="Actions" filterable="false">
    <ng-template kendoGridCellTemplate let-isNew="isNew" let-dataItem>
      <div class="flex-row actions">
        <a
          mat-raised-button
          *ngFor="let url of dataItem.lstUrlCreationPgm"
          matTooltip="Création PGM"
          color="primary"
          [href]="url.urlCreationPgm"
          target="_blank"
        >
          {{ url.nomSousSysteme }}
        </a>

        <button mat-icon-button matTooltip="Détails" (click)="dispatchDeepLoadSelectedItem(dataItem.id)" color="primary">
          <mat-icon>info</mat-icon>
        </button>

        <button *ngIf="existsSessionForCurrentUser$ | async" kendoGridRemoveCommand mat-icon-button color="primary" matTooltip="Supprimer">
          <mat-icon>delete</mat-icon>
        </button>
      </div>
    </ng-template>
  </kendo-grid-command-column>
</kendo-grid>
